import { useState, useRef, useEffect } from "react";
import { FiSearch, FiArrowRight, FiBriefcase, FiStar } from "react-icons/fi";
import peopleGroup from "../assets/careers-people-grouped.png";
import { Helmet } from "react-helmet-async";

const CareersSection = () => {
  const jobList = [
    {
      title: "Python Developer",
      description:
        "We are looking for a passionate and self-motivated Python Developer (Fresher) to join our ...",
      link: "/careers/python-developer/",
    },
    {
      title: "Flutter Mobile App Developer",
      description:
        "We are looking for a talented and passionate Flutter Developer to join our ...",
      link: "/careers/flutter-developer/",
    },
    {
      title: "Java Developer",
      description:
        "Looking for a Java developer to build scalable backend systems...",
      link: "/careers/java-developer/",
    },
    {
      title: "PHP Developer",
      description:
        "We are on the lookout for a motivated and enthusiastic PHP Developer to join us ...",
      link: "/careers/php-developer/",
    },
    {
      title: "UI/UX Designer",
      description:
        "We are looking for a creative UI/UX designer to improve user experience...",
      link: "/careers/ui-ux-designer/",
    },
    {
      title: "React Developer",
      description:
        "We are on the hunt for a motivated and detail-oriented React Developer Fresher ...",
      link: "/careers/react-developer/",
    },
  ];

  const [viewAll, setViewAll] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const jobListRef = useRef(null);

  // Scroll to job list after viewAll is set
  useEffect(() => {
    if (viewAll && jobListRef.current) {
      jobListRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [viewAll]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredJobs = jobList.filter((job) =>
    job.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Helmet>
        <title>Join LENTERA | High-Demand Roles in Tech, Design & Sales.</title>
        <meta
          name="description"
          content="Build a meaningful career at LENTERA with a rewarding, inspiring work environment. Explore full-time opportunities for freshers in Sales, Marketing, UI/UX Design, Python, and React development.
"
        />
        <meta
          name="keywords"
          content="LENTERA careers, tech job opportunities, UI/UX designer jobs, Python developer roles, React developer openings, sales and marketing jobs, fresher job opportunities, rewarding work environment.
"
        />
      </Helmet>
      {/* Main Section */}

      <section className="w-full bg-[#F7F8FA] font-poppins px-4 md:px-10 py-20 overflow-hidden">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-start justify-between gap-10">
          {/* Left Side */}

          <div className="relative w-full lg:w-[60%] px-4 sm:px-6 md:px-10">
            {/* Heading */}
            <h2 className="text-[28px] sm:text-[36px] md:text-[48px] font-semibold text-[#1E1E1E] leading-tight mb-6">
              We're a community united by <br className="hidden sm:block" />
              shared values & purpose.
            </h2>

            {/* Paragraph */}
            <p className="text-[#4B5563] text-[16px] sm:text-[18px] leading-[28px] mb-10 max-w-[600px]">
              Building a meaningful career is a journey — our goal is to make it
              seamless by offering a rewarding and inspiring work environment.
            </p>

            {/* People Group Image */}
            <div className="relative w-full max-w-[800px] mx-auto">
              <img
                src={peopleGroup}
                alt="People Group"
                className="w-full h-auto mt-12 relative z-10"
              />
            </div>
          </div>

          {/* Right Side – Image and Content */}

          <div className="w-full lg:w-[36%] bg-white rounded-xl shadow-md px-6 py-8">
            <h4 className="text-[#6B7280] text-[14px] font-medium uppercase mb-6">
              HIGH DEMAND ROLES
            </h4>

            {/* List Items */}
            {[
              {
                title: "Sales and Marketing Associate",
                link: "/careers/sales-marketing",
              },
              {
                title: "Designers– UI/UX & Visual / Graphic",
                link: "/careers/ui-ux-designer",
              },
              { title: "Python Developer", link: "/careers/python-developer" },
              { title: "React Developer", link: "/careers/react-developer" },
            ].map((job, idx) => (
              <a
                key={idx}
                href={job.link}
                className="flex items-center justify-between border-b border-gray-200 py-4 group"
              >
                <div>
                  <h3 className="text-green-600 font-semibold text-[16px] group-hover:underline">
                    {job.title}
                  </h3>
                  <p className="text-gray-500 text-[14px]">
                    Full time | Fresher
                  </p>
                </div>
                <FiArrowRight className="text-gray-400 group-hover:text-green-600 transition" />
              </a>
            ))}

            {/* View All Button */}
            <button
              onClick={() => setViewAll(true)}
              className="w-full mt-6 bg-[#F3F4F6] text-[#1F2937] text-[14px] font-semibold py-3 rounded-full hover:bg-gray-200 transition flex items-center justify-center gap-2"
            >
              VIEW ALL <FiArrowRight />
            </button>
          </div>
        </div>
      </section>

      {/* Job Listings Section */}
      {viewAll && (
        <section
          ref={jobListRef}
          className="w-full font-poppins px-4 md:px-10 py-20 bg-white"
        >
          <h2 className="text-center text-[36px] md:text-[40px] font-semibold text-[#1E1E1E] mb-10">
            Opportunities to grow your career
          </h2>

          {/* Search Bar */}
          <div className="max-w-[800px] mx-auto mb-12 relative">
            <FiSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-xl" />
            <input
              type="text"
              placeholder="Search job title..."
              value={searchTerm}
              onChange={handleSearch}
              className="w-full pl-12 pr-4 py-4 rounded-full border border-gray-200 shadow-sm text-[16px] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500"
            />
          </div>

          {/* Job Cards */}
          <div className="max-w-[1400px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredJobs.length > 0 ? (
              filteredJobs.map((job, index) => (
                <div
                  key={index}
                  className="group bg-white border border-gray-200 rounded-xl shadow-sm p-6 transform transition duration-300 hover:scale-[1.02] hover:shadow-md hover:border-blue-400"
                >
                  <h3 className="text-[18px] font-semibold text-green-600 mb-2">
                    {job.title}
                  </h3>
                  <p className="text-gray-500 text-[14px] leading-[22px] mb-4">
                    {job.description}
                  </p>

                  <div className="flex flex-col gap-2 text-[14px] text-[#111827] mb-6">
                    <div className="flex items-center gap-2">
                      <FiBriefcase className="text-[16px]" />
                      <span>Full time</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <FiStar className="text-[16px]" />
                      <span>Fresher</span>
                    </div>
                  </div>

                  <a
                    href={job.link}
                    className="group flex items-center justify-between w-full bg-[#F3F4F6] text-[#111827] text-[14px] font-semibold px-5 py-3 rounded-full hover:bg-gray-200 transition"
                  >
                    View job details
                    <FiArrowRight className="ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                  </a>
                </div>
              ))
            ) : (
              <p className="text-center col-span-full text-gray-500 text-lg">
                No matching jobs found.
              </p>
            )}
          </div>
        </section>
      )}
    </>
  );
};

export default CareersSection;
